import axios from 'axios';
import { CepData } from '../types';

const CEP_API_URL = process.env.REACT_APP_CEP_API_URL || 'https://viacep.com.br/ws';

export const cepService = {
  async buscarCep(cep: string): Promise<CepData | null> {
    try {
      const cepLimpo = cep.replace(/\D/g, '');

      if (cepLimpo.length !== 8) {
        return null;
      }

      const response = await axios.get<CepData>(
        `${CEP_API_URL}/${cepLimpo}/json/`
      );

      if (response.data.erro) {
        return null;
      }

      return response.data;
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      return null;
    }
  }
};
